import { FaBarcode, FaCreditCard, FaFileAlt, FaPlus, FaQrcode } from 'react-icons/fa';
import { AiFillBank } from 'react-icons/ai';
import { FC, ReactNode, useEffect, useState } from "react"
import { FormaPagamentoType, TiposPagamentoIDType } from "src/types"
import './styles.scss'
import { BOLETO, BOLETO_CARTAO, BOLETO_FINANCIAMENTO, BOLETO_FINANCIAMENTO_INDIRETO, CARTAO_CREDITO, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO, CARTAO_FINANCIAMENTO, FINANCIAMENTO, FINANCIMENTO_INDIRETO, PIX, PIX_CARTAO, PIX_FINANCIAMENTO, PIX_FINANCIAMENTO_INDIRETO } from "src/constants";
import { FormaPagamentoIcons } from './FormaPagamentoIcons';


interface FormaPagamentoProperties {
    formaPagamento: FormaPagamentoType,
    selected?: boolean,
    disabled?: boolean,
    onSelected: () => void
}

const FormaPagamento: FC<FormaPagamentoProperties> = ({
    formaPagamento,
    selected = false,
    disabled: _disabled,
    onSelected,
}) => {
    const [disabled, setDisabled] = useState<boolean>(false);

    useEffect(() => {
        setDisabled(_disabled === true)
    }, [_disabled])

    return <div className="FormaPagamento">
        <div className={`content${selected ? " selected" : ""}${disabled ? " disabled" : ""} ${_disabled}`}
            onClick={() => {
                if (disabled) {
                    return;
                }
                onSelected();
            }}
        >
            <div className="title">{formaPagamento.nome}</div>
            <div className="icon">
                <FormaPagamentoIcons tipoPagamentoId={formaPagamento.id as any} />
            </div>
        </div>
    </div>
}

export { FormaPagamento }